import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LogoutButton from './LogoutButton';

interface UserProfileProps {
  showLogoutButton?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const UserProfile: React.FC<UserProfileProps> = ({
  showLogoutButton = true,
  className,
  style,
}) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className={className} style={{ ...styles.container, ...style }}>
      <div style={styles.userInfo}>
        <div style={styles.avatar}>
          {user.picture ? (
            <img
              src={user.picture}
              alt={user.name || 'User'}
              style={styles.avatarImage}
            />
          ) : (
            <div style={styles.avatarPlaceholder}>
              {(user.name || user.email || 'U').charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        
        <div style={styles.userDetails}>
          <div style={styles.userName}>
            {user.name || user.preferred_username || user.email}
          </div>
          {user.email && user.name && (
            <div style={styles.userEmail}>{user.email}</div>
          )}
        </div>
      </div>

      {showLogoutButton && (
        <div style={styles.logoutContainer}>
          <LogoutButton variant="link" size="small" />
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.5rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e9ecef',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as const,
  },
  avatarPlaceholder: {
    width: '100%',
    height: '100%',
    backgroundColor: '#007bff',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
    fontWeight: 'bold' as const,
  },
  userDetails: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '0.25rem',
  },
  userName: {
    fontSize: '0.9rem',
    fontWeight: 'bold' as const,
    color: '#333',
    margin: 0,
  },
  userEmail: {
    fontSize: '0.75rem',
    color: '#666',
    margin: 0,
  },
  logoutContainer: {
    flexShrink: 0,
  },
};

export default UserProfile;